import { Box, Button, Link, Text } from '@chakra-ui/react';
import React, { useState } from 'react';

declare function gtag(...args: unknown[]): void;

const CONSENT_KEY = 'cookie_consent';

const CookieBanner = (): React.JSX.Element | null => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
  };

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="#16161f"
      py={4}
      zIndex={9999}
      style={{ fontFamily: 'Lato' }}
    >
      <Box
        className="mx-auto max-w-[90vw] lg:max-w-[85vw] xl:max-w-[1100px]"
        display="flex"
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'stretch', md: 'center' }}
        gap={4}
      >
        <Box flex={1}>
          <Text color="white" fontSize="md" fontWeight="bold" mb={1}>
            We use cookies
          </Text>
          <Text color="white" fontSize="sm">
            We may place these for analysis of our visitor data, to improve our website, show
            personalised content and to give you a great website experience. For more information
            about the cookies view our{' '}
            <Link
              href="https://content.olympiq.co.uk/documents/Olympiq_Cookie_Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              color="white"
              textDecoration="underline"
            >
              Cookie Policy
            </Link>
            .
          </Text>
        </Box>

        <Box display="flex" gap={3} flexShrink={0}>
          <Button
            size="sm"
            variant="outline"
            color="white"
            borderColor="white"
            _hover={{ bg: 'whiteAlpha.200' }}
            onClick={handleReject}
          >
            Reject
          </Button>
          <Button
            size="sm"
            bg="white"
            color="#16161f"
            _hover={{ bg: 'whiteAlpha.800' }}
            onClick={handleAccept}
          >
            Accept
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CookieBanner;
